import {
    SET_NEW_USER,
    GET_QUALIFICATIONS,
    SET_NEW_CREW,
    GET_USER_TYPES,
    SUBMIT_NEW_USER_TYPES,
    DELETE_USER_TYPE,
    GET_DEPARTMENTS,
    GET_AREAS,
    SUBMIT_NEW_AREA,
    SUBMIT_NEW_DEPARTMENT,
    GET_ALL_USERS,
} from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import uuid from "uuid/v1";
export const setNewUser = (newuser, password, emails, callback) => {
    return (dispatch) => {
        dispatch({ type: SET_NEW_USER.REQUEST });
        if (password.length >= 6 && !emails.includes(newuser.email)) {
            let cloudFunction = firebase.functions().httpsCallable("addUser");
            if (newuser.profile_image_url !== "") {
                try {
                    firebase
                        .storage()
                        .ref(`/users/${newuser.account_created}`)
                        .put(newuser.profile_image_url)
                        .then((snapshot) => {
                            snapshot.ref.getDownloadURL().then((url) => {
                                newuser.profile_image_url = url;
                                cloudFunction({ newuser, password }).then(
                                    (e) => {
                                        let key = e.data.uid;
                                        let label = `${newuser.first_name} ${newuser.last_name}`
                                        firebase
                                            .database()
                                            .ref("/collections/user_uid_names/"+key)
                                            .set(label)
                                        firebase
                                            .database()
                                            .ref(
                                                "/collections/seated_user_limit"
                                            )
                                            .once("value", (snapshot) => {
                                                let limit = snapshot.val();
                                                if (
                                                    typeof limit !==
                                                        "undefined" ||
                                                    limit !== null
                                                ) {
                                                    firebase
                                                        .database()
                                                        .ref(
                                                            "/collections/seated_users"
                                                        )
                                                        .once(
                                                            "value",
                                                            (snap) => {
                                                                let userSeats =
                                                                    snap.val() ||
                                                                    [];
                                                                if (userSeats)
                                                                    userSeats = [
                                                                        ...userSeats,
                                                                        e.uid,
                                                                    ];
                                                                if (
                                                                    limit >=
                                                                    userSeats.length
                                                                )
                                                                    firebase
                                                                        .database()
                                                                        .ref(
                                                                            "/collections/seated_users/"
                                                                        )
                                                                        .set(
                                                                            userSeats
                                                                        );
                                                            }
                                                        );
                                                }
                                            });
                                        dispatch({
                                            type: SET_NEW_USER.SUCCESS,
                                            payload: false,
                                        });
                                        callback(true);
                                    }
                                );
                            });
                        })
                        .catch(() => {
                            dispatch({
                                type: SET_NEW_USER.FAIL,
                                payload: false,
                            });
                            callback(false);
                        });
                } catch (e) {
                    dispatch({ type: SET_NEW_USER.FAIL, payload: false });
                    callback(false);
                }
            } else {
                cloudFunction({ newuser, password }).then((e) => {
                    let key = e.data.uid;
                    let label = `${newuser.first_name} ${newuser.last_name}`
                    firebase
                        .database()
                        .ref("/collections/user_uid_names/"+key)
                        .set(label)
                        firebase
                        .database()
                        .ref("/collections/seated_user_limit")
                        .once("value", (snapshot) => {
                            let limit = snapshot.val();
                            if (
                                typeof limit !== "undefined" ||
                                limit !== null
                            ) {
                                firebase
                                    .database()
                                    .ref("/collections/seated_users")
                                    .once("value", (snap) => {
                                        let userSeats = snap.val() || [];
                                        if (userSeats)
                                            userSeats = [
                                                ...userSeats,
                                                e.data.uid,
                                            ];
                                        if (limit >= userSeats.length)
                                            firebase
                                                .database()
                                                .ref(
                                                    "/collections/seated_users/"
                                                )
                                                .set(userSeats);
                                    });
                            }
                        })
                    // });
                    dispatch({
                        type: SET_NEW_USER.SUCCESS,
                        payload: false,
                    });
                    callback(true);
                });
            }
        } else {
            dispatch({ type: SET_NEW_USER.FAIL, payload: false });
            callback(false);
        }
    };
};
export const getUserTypes = () => {
    return (dispatch) => {
        dispatch({ type: GET_USER_TYPES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_USER_TYPES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/user_types")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_USER_TYPES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_USER_TYPES.FAIL });
        }
    };
};
export const getDepartments = () => {
    return (dispatch) => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};
export const getAreas = () => {
    return (dispatch) => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};
export const submitNewDepartment = (label, callback) => {
    return (dispatch) => {
        dispatch({ type: SUBMIT_NEW_DEPARTMENT.REQUEST });
        let key = label.toLowerCase().replace(/ /g, "_");
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SUBMIT_NEW_DEPARTMENT.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments/" + key)
                        .set(label);

                    callback(true);
                    dispatch({ type: SUBMIT_NEW_DEPARTMENT.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: SUBMIT_NEW_DEPARTMENT.FAIL });
        }
    };
};
export const submitNewArea = (label, callback) => {
    return (dispatch) => {
        dispatch({ type: SUBMIT_NEW_AREA.REQUEST });
        let key = label.toLowerCase().replace(/ /g, "_");
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SUBMIT_NEW_AREA.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas/" + key)
                        .set(label);

                    callback(true);
                    dispatch({ type: SUBMIT_NEW_AREA.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: SUBMIT_NEW_AREA.FAIL });
        }
    };
};
export const submitNewUserTypes = (user_type, callback) => {
    return (dispatch) => {
        dispatch({ type: SUBMIT_NEW_USER_TYPES.REQUEST });
        let key = user_type.title.toLowerCase().replace(/ /g, "_");
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SUBMIT_NEW_USER_TYPES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/user_types/" + key)
                        .update(user_type)
                        .then(() => {
                            callback(true);
                            dispatch({ type: SUBMIT_NEW_USER_TYPES.SUCCESS });
                        })
                        .catch(() => {
                            callback(false);
                            dispatch({ type: SUBMIT_NEW_USER_TYPES.FAIL });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: SUBMIT_NEW_USER_TYPES.FAIL });
        }
    };
};
export const getQualifications = () => {
    return (dispatch) => {
        dispatch({ type: GET_QUALIFICATIONS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_QUALIFICATIONS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/required_qualifications")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_QUALIFICATIONS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_QUALIFICATIONS.FAIL });
        }
    };
};
export const setNewCrewUser = (newCrew, emails, successCallback) => {
    return (dispatch) => {
        dispatch({ type: SET_NEW_CREW.REQUEST });
        let uid = uuid();

        newCrew.uid = uid;

        if (!emails.includes(newCrew.email)) {
            if (newCrew.profile_image_url !== "") {
                try {
                    firebase
                        .storage()
                        .ref(`/users/${newCrew.account_created}`)
                        .put(newCrew.profile_image_url)
                        .then((snapshot) => {
                            snapshot.ref.getDownloadURL().then((url) => {
                                newCrew.profile_image_url = url;
                                firebase.auth().onAuthStateChanged((user) => {
                                    if (user) {
                                        firebase
                                            .database()
                                            .ref(`/users/${newCrew.uid}/`)
                                            .update({ profile: newCrew })
                                            .then(() => {
                                                successCallback(true);
                                                dispatch({
                                                    type: SET_NEW_CREW.SUCCESS,
                                                });
                                            })
                                            .catch(() => {
                                                successCallback(false);
                                                dispatch({
                                                    type: SET_NEW_CREW.FAIL,
                                                });
                                            });
                                    } else {
                                        dispatch({ type: SET_NEW_CREW.FAIL });
                                        successCallback(false);
                                    }
                                });
                            });
                        });
                } catch {
                    dispatch({ type: SET_NEW_CREW.FAIL });
                    successCallback(false);
                }
            } else {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/users/${newCrew.uid}/`)
                            .update({ profile: newCrew })
                            .then(() => {
                                successCallback(true);
                                dispatch({ type: SET_NEW_CREW.SUCCESS });
                            })
                            .catch(() => {
                                successCallback(false);
                                dispatch({ type: SET_NEW_CREW.FAIL });
                            });
                    } else {
                        dispatch({ type: SET_NEW_CREW.FAIL });
                        successCallback(false);
                    }
                });
            }
        } else {
            dispatch({ type: SET_NEW_CREW.FAIL });
            successCallback(false);
        }
    };
};

export const removeUserType = (key) => {
    return (dispatch) => {
        dispatch({ type: DELETE_USER_TYPE.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: DELETE_USER_TYPE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/user_types/${key}`)
                        .remove();
                    dispatch({ type: DELETE_USER_TYPE.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: DELETE_USER_TYPE.FAIL });
        }
    };
};

export const getAllUsers = () => {
    return (dispatch) => {
        dispatch({ type: GET_ALL_USERS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_ALL_USERS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_ALL_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_ALL_USERS.FAIL });
        }
    };
};

export const generateQualAlerts = (alerts = false) => {
    return (dispatch) => {
        if (alerts) {
            Object.keys(alerts).map((e) => {
                let uid = alerts[e].uid;
                let details = alerts[e].details;
                firebase
                    .database()
                    .ref(`/subjects/alerts/qualification_expiry/${uid}`)
                    .update(details);
                return null;
            });
        }
    };
};